import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export type JumpAction = {
  code: string; // "Digit2" — keyboard shortcut + source of the digit label
  path: string; // "/appointments"
  key: string; // "appointments" — i18n key under jumpMenu.*
  defaultValue: string; // "Appointments"
};

export const JUMP_ACTIONS: JumpAction[] = [
  { code: "Digit1", path: "/patients", key: "patients", defaultValue: "Patients" },
  {
    code: "Digit2",
    path: "/appointments",
    key: "appointments",
    defaultValue: "Appointments",
  },
  {
    code: "Digit3",
    path: "/appointments/new",
    key: "new_appointment",
    defaultValue: "New Appointment",
  },
];

export function useJumpShortcuts(onTrigger?: () => void) {
  const navigate = useNavigate();

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (!e.shiftKey || e.ctrlKey || e.altKey || e.metaKey) return;

      const active = document.activeElement as HTMLElement | null;
      if (active) {
        const tag = active.tagName;
        const isTyping =
          tag === "INPUT" || tag === "TEXTAREA" || active.isContentEditable;
        if (isTyping) return;
      }

      const match = JUMP_ACTIONS.find((sc) => sc.code === e.code);
      if (!match) return;

      e.preventDefault();
      onTrigger?.();
      navigate(match.path);
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [navigate, onTrigger]);
}
